import { Card, Col, Row } from "antd";
import { useSelector } from "react-redux";
import ModeTable from "./ModeTable";
import { HistoryOutlined } from "@ant-design/icons";
import {
  formatDateAndTime,
  getGrafanaBaseURL,
} from "../../../../../Common/Utils";
import VehicleDetails from "../../../../VehicleDetails";
import { EOL_TESTS } from "../../../../../Common/Grafana/Constants";
import GetIframe from "../../../../../Common/Grafana/GetIframe";
import { useMemo } from "react";

const Result = ({ onChangeImei, vehicle, rearTyreDiameter }) => {
  const eol = useSelector((state) => state.eol);
  const response = eol?.dynoResult;

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      // imei: vehicle?.vehImei,
      vehicle_id: vehicle?.vehId,
      rear_wheel_diameter: rearTyreDiameter,
      refresh: "5s",
    };
    // eslint-disable-next-line
  }, [vehicle?.vehId, rearTyreDiameter]);

  return (
    <Row>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={5} xl={5}>
            <VehicleDetails onChangeImei={onChangeImei} imei={vehicle} cardHeight={"100%"} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={19} xl={19}>
            <Card
              className="h100"
              title="Dyno Result"
              styles={{ body: { padding: "4px", minHeight: "243px" } }}
              extra={
                response?.startTime && (
                  <div className="fs13">
                    <HistoryOutlined />
                    <span className="card-sub-text ml05">
                      {formatDateAndTime(response?.startTime)}
                    </span>
                  </div>
                )
              }
            >
              <ModeTable />
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="mt1">
          <Col xs={24} sm={24} md={24} lg={12} xl={12} id="dyno-current">
            {vehicle?.vehId && (
              <GetIframe
                title="Dyno Current"
                url={getGrafanaBaseURL(
                  EOL_TESTS.DYNO.DASHBOARD_ID,
                  EOL_TESTS.DYNO.DASHBOARD_NAME
                )}
                panelId={EOL_TESTS.DYNO.PANEL_ID["current"]}
                variableObject={baseFilterObject}
                variableKeys={EOL_TESTS.DYNO.RUNNING_VARIABLES}
                width="100%"
                height="220"
                divId="dyno-current"
              />
            )}
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} id="dyno-speed">
            {vehicle?.vehId && (
              <GetIframe
                title="Dyno Speed"
                url={getGrafanaBaseURL(
                  EOL_TESTS.DYNO.DASHBOARD_ID,
                  EOL_TESTS.DYNO.DASHBOARD_NAME
                )}
                panelId={EOL_TESTS.DYNO.PANEL_ID["speed"]}
                variableObject={baseFilterObject}
                variableKeys={EOL_TESTS.DYNO.RUNNING_VARIABLES}
                width="100%"
                height="220"
                divId="dyno-speed"
              />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default Result;
